<div mat-dialog-title>
  <fa-icon [icon]="faLaptopBinary"></fa-icon>
  <h2>Logic notes</h2>
</div>
<div mat-dialog-content>
  <p>{{ data.programmerNotes }}</p>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onCancel()">Close</button>
</div>
